import {Pipe, PipeTransform} from '@angular/core';

import {LanguageService} from '../language.service';
import {GetProductMaturityOptions} from "../../pages/portal/services/products/products.functions";

@Pipe({
	name: 'productMaturity'
})
export class ProductMaturityPipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: number): string {
		const options = GetProductMaturityOptions(this.languageService.getCurrentLanguage());

		if (options.length > value) {
			return options[value]?.label;
		}

		return '';
	}
}
